// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"09ea713a","298":"979252f0","453":"b070eb33","888":"58ca8216"}[chunkId] + ".chunk.js";
};